module.exports = __webpack_public_path__ + "static/img/subscribe_qr_code.24a1e4b.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/home/subscribe_qr_code.png
// module id = H0CX
// module chunks = 21